import moment from 'moment';

export const emptySelectItemId = 'empty';

export const frontDateFormat = 'DD.MM.YYYY';
export const backDateFormat = 'YYYY-MM-DD';

export const formatBackToFrontDate = (backDate: string) => {
  const bd = moment(backDate, backDateFormat);

  return bd.format(frontDateFormat);
};

export const mainGridColumns = '767fr 393fr';

export const SPECIAL_FOLDER_NAME = 'Без папки';

export const NEW_MODEL_ID = 'NEW_MODEL_ID';

export const regulars = {
  onlyKirilic: /^[а-яА-ЯёЁ\s-]*$/,
  mosRuEmail: /^([A-Za-z0-9]|-|_){4,30}@transport.mos.ru$/,
};

export enum BackErrors {
  FileExists = 'File exists',
  TableExists = 'Table exists',
  FolderExists = 'Folder exists',
  EntityExists = 'Entity exists',
  SectionExists = 'Section exists',
}

export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const undefinedOnTouchDevice = <T>(arg: T) => {
  return isTouchDevice() ? undefined : arg;
};

declare global {
  interface Window {
    deeplog: (val: any) => void;
  }
}
window.deeplog = (val: any) => {
  console.log(JSON.parse(JSON.stringify(val)));
};
